import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

function StatusIcon({ routeView }) {
  const { totalStopsInProgress, totalOpenEventLogs, route } = routeView;
  const statusClass = (totalStopsInProgress) ? 'STOPS_IN_PROGRESS' : route.status;

  const existAlert = useMemo(() => {
    const eventNotificationIsEnabled = Monet.Security.checkKeyIsEnabled(['TRACKER_EVENT_NOTIFICATION']);

    return totalOpenEventLogs && eventNotificationIsEnabled;
  }, []);

  const className = `routeMonitorRouteStatusIcon ${statusClass}`;

  return (
    <div data-testid={`${route.key}-card-status`}>
      <div className={className} data-testid="card-status-type" />
      {existAlert ? (
        <div
          className="routeAlertBadge"
          data-alerts={totalOpenEventLogs}
          data-testid="card-status-event-badge"
        />
      ) : null}
    </div>
  );
}

StatusIcon.propTypes = {
  routeView: PropTypes.object.isRequired
};

export default StatusIcon;
